import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      // 页面标题title
      title: "布络会员系统",
    },
  },
  {
    path: "/admin",
    name: "admin",
    component: () => import("../views/AdminView.vue"),
    meta: {
      // 页面标题title
      title: "布络会员系统",
    },
    children: [
      {
        path: "/admin/product",
        name: "product",
        component: () => import("../views/ProductView.vue"),
      },
      {
        path: "/admin/purchaseRecord",
        name: "purchaseRecord",
        component: () => import("../views/PurchaseRecordView.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  // base:'/member/',
  routes,
});

export default router;
